import { NAME } from './constants';

export const SIGN_IN = `${NAME}.SIGN_IN`;
export const SET_AUTH_DATA = `${NAME}.SET_AUTH_DATA`;
export const FETCH_USER_INFO = `${NAME}.FETCH_USER_INFO`;
export const FETCH_USER_USAGE = `${NAME}.FETCH_USER_USAGE`;
export const INITIAL_AUTH = `${NAME}.INITIAL_AUTH`;
export const LOGOUT = `${NAME}.LOGOUT`;
